function ArtHack() {
    return (<div>
        As 2nd term was very busy this year, we set out to create a simple interactive piano. Using a projector and a camera, we tracked when keys were pressed and played the correct note. We ended up winning the "Most Interactive" category in the competition.
    </div>);
}

export default ArtHack;